import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const OrganizationLimitsModal = ({ show, onHide, organization, onLimitsUpdated }) => {
    const [storageLimit, setStorageLimit] = useState('');

    useEffect(() => {
        if (organization) {
            const limitInMb = organization.limits?.storage_limit_bytes !== null && organization.limits?.storage_limit_bytes !== undefined
                ? (organization.limits.storage_limit_bytes / (1024 * 1024)).toString()
                : '';
            setStorageLimit(limitInMb);
        }
    }, [organization]);

    const handleSave = async () => {
        const limit = storageLimit ? parseInt(storageLimit, 10) : null;

        if (limit !== null && limit < 0) {
            toast.error('Лимит не может быть отрицательным числом.');
            return;
        }

        try {
            const payload = {
                storage_limit_mb: limit,
            };
            await apiClient.put(`/admin/organizations/${organization.id}/limits`, payload);
            toast.success('Лимиты организации успешно обновлены!');
            onLimitsUpdated();
            onHide();
        } catch (err) {
            toast.error('Ошибка при обновлении лимитов.');
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Лимиты для "{organization?.name}"</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Лимит хранилища</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="number"
                            value={storageLimit}
                            onChange={(e) => setStorageLimit(e.target.value)}
                            placeholder="По умолчанию (500 MB)"
                            min="0"
                        />
                        <InputGroup.Text>MB</InputGroup.Text>
                    </InputGroup>
                    <Form.Text className="text-muted">
                        Оставьте поле пустым, чтобы использовать значение по умолчанию. Введите 0, чтобы запретить загрузку.
                    </Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OrganizationLimitsModal;
